import { fetchPageAssets } from '../../ducks/hostedAssets.duck';
import { fetchListingCollections } from '../../ducks/listingCollections.duck';
import { landingPageCollections } from '../../config/configListingCollections';

export const ASSET_NAME = 'landing-page';

export const loadData = (params, search, config) => dispatch => {
  const pageAsset = { landingPage: `content/pages/${ASSET_NAME}.json` };

  // Collections are fetched here rather than in the component so that they are
  // server-rendered: the cards then ship as crawlable links in the landing page HTML.
  return Promise.all([
    dispatch(fetchPageAssets(pageAsset, true)),
    dispatch(fetchListingCollections(landingPageCollections, { config })),
  ]);
};
